import { CreateVenueComponent } from './create-venue/create-venue.component';
import { VenuesService } from './venues.service';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, Signal, ViewChild, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonRefresher, IonicModule, ModalController } from '@ionic/angular';
import { Venue } from '../_shared/models/csTypes/venue';
import { Observable, Subject, startWith, switchMap, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { EmptyPageModule } from '../empty-page/empty-page.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-venues',
  templateUrl: './venues.component.html',
  styleUrls: ['./venues.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    RouterLink,
    EmptyPageModule,
    TranslateModule
  ],

})
export class VenuesComponent {
  private modalController = inject(ModalController);
  @ViewChild('refresher') refresher: IonRefresher;

  venueService = inject(VenuesService)

  private refreshVenues$ = new Subject<void>();

  venues$: Observable<Venue[]> = this.refreshVenues$.pipe(
    startWith(undefined),
    switchMap(() => {
        return this.venueService.myVenues();
    }),
    tap(() => this.refresher.complete())
  )
  
  venues: Signal<Venue[]> = toSignal(this.venues$);

  loaded = computed(() => {    
    return !!this.venues()
  })

  doRefresh() {
    this.refreshVenues$.next();
  }

  async createVenue() {

    const modal = await this.modalController.create({
      component: CreateVenueComponent,
      initialBreakpoint: 0.3,
      breakpoints: [0.3, 1],
      showBackdrop: true
    });
  
    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data)
      this.venues().push(data);
    }

}
